import React from "react";
import "../styles/NavrightList.css";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Person2Icon from "@mui/icons-material/Person2";
import { Link } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContextProvider";
import { useContext } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
function NavrightList({ open }) {
  const { isAuth } = useContext(AuthContext);

  return (
    <ul className="navright_list">
      <li>
        {" "}
        <span>
          <LocationOnIcon />
        </span>
        <span> {isAuth ? "413534" : "Select your PIN"}</span>
      </li>
      <li>|</li>
      <li>
        <Link style={{ textDecoration: "none", color: "white" }} to="/cart">
          <span>
            <ShoppingCartIcon className="cart_icon" />
            cart
          </span>
        </Link>
      </li>
      <li>|</li>
      <li>
        <Link style={{ textDecoration: "none", color: "white" }} to="/login">
          <span>
            <Person2Icon /> Login
          </span>
        </Link>
      </li>
    </ul>
  );
}

export default NavrightList;
